import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import PageWrapper from "@/components/layout/PageWrapper";

const NotFound = () => (
  <PageWrapper title="Page not found — ADHD School">
    <section className="adhd-container py-32 text-center">
      <p className="adhd-eyebrow">404</p>
      <h1 className="mt-3 font-serif text-5xl sm:text-6xl text-[color:var(--adhd-text)]">
        We couldn't find that page.
      </h1>
      <p className="mt-3 text-[color:var(--adhd-muted)]">
        Let's take you somewhere helpful.
      </p>
      <Link to="/" data-testid="notfound-home" className="adhd-btn-primary mt-8 inline-flex">
        <HomeIcon size={14} /> Back to Home
      </Link>
    </section>
  </PageWrapper>
);

export default NotFound;
